<template>
    <!-- The header's "Task" quick add: a new card in the first column of your task manager (set up on first use) -->
    <add-new-company-board-item v-if="item" :item="item" :tags="tags" heading="Add Task" @close="onClose" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import axios from 'axios';
import AddNewCompanyBoardItem from '@/components/AddNewCompanyBoardItem.vue';

export default defineComponent({
    name: 'QuickAddTask',
    emits: [ 'close' ],
    components: {
        AddNewCompanyBoardItem
    },
    data() {
        return {
            board: null as any,
            item: null as any,
            tags: [] as any[]
        }
    },
    async created() {
        try {
            const board = (await axios.post(`${this.$store.state.apiUrl}/api/companyboards/taskmanager`)).data;
            const details = (await axios.get(`${this.$store.state.apiUrl}/api/companyboards/${board.Slug}`)).data;
            const columns = JSON.parse(details.Columns || '[]');
            this.board = board;
            this.tags = JSON.parse(details.Tags || '[]');
            this.item = {
                ID: null,
                Name: '',
                Description: '',
                Column: columns[0]?.name || '',
                TagsJSON: [],
                Date: null,
                Slug: board.Slug
            };
        } catch(e: any) {
            console.log(e);
            alert(e?.response?.data || 'There was an error opening your task manager');
            this.$emit('close');
        }
    },
    methods: {
        onClose(id: any) {
            if(id) {
                this.$store.state.quickAddToast = {
                    text: `Added to ${this.board.Name}.`,
                    link: { label: 'View Task', to: `/deck/${this.board.Slug}?openCard=${id}` }
                };
            }
            this.$emit('close');
        }
    }
});
</script>
